<script setup lang="ts">
import { ref, type StyleValue } from "vue";

import { hasValue } from "@/Utils/Objects";

export interface GridContainerProps {
  area?: string;
  align?: "center" | "start" | "end";
  justify?: "center" | "start" | "end";
  style?: StyleValue;
  direction?: "row" | "column";
}

const props = withDefaults(defineProps<GridContainerProps>(), { align: "center", justify: "start" });

const columnRef = ref<HTMLDivElement | null>(null);

defineExpose({ columnRef });
</script>

<template>
  <div
    class="grid-column"
    ref="columnRef"
    :style="{
      ...(hasValue(props.style) ? (props.style as object) : {}),
      'grid-area': props.area,
      'align-items': props.align,
      'justify-content': props.justify,
      'flex-direction': props.direction,
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss">
.grid-column {
  display: flex;

  & > div {
    width: 100%;
  }
}
</style>
